import { AccountType } from "@common/constants/domains/accounting/accounts";
import { isScheduleRecognitionAccountType } from "@common/constants/domains/accounting/scheduleAccountFilters";
import { ScheduleType } from "@common/types/domains/accounting/schedule";

/**
 * The account a bill schedule recognizes into: the one expense account every
 * scheduled bill line sits in. Null when the lines disagree, a line has no
 * account, or that account can't take recognition, so the policy's own
 * recognition account applies.
 */
export function resolveBillRecognitionAccountId(options: {
    scheduleType: ScheduleType;
    lineAccountIds: Array<string | null>;
    getAccountType: (accountId: string) => AccountType | undefined;
}): string | null {
    const [accountId] = options.lineAccountIds;
    if (
        !accountId ||
        options.lineAccountIds.some(
            (lineAccountId) => lineAccountId !== accountId,
        )
    ) {
        return null;
    }
    const accountType = options.getAccountType(accountId);
    return accountType !== undefined &&
        isScheduleRecognitionAccountType({
            accountType,
            scheduleType: options.scheduleType,
        })
        ? accountId
        : null;
}

export function selectScheduledBillLines<T extends { id: string }>(options: {
    lines: T[];
    sourceLineIds: string[] | undefined;
}): T[] {
    const { lines, sourceLineIds } = options;
    return sourceLineIds?.length
        ? lines.filter((line) => sourceLineIds.includes(line.id))
        : lines;
}
